import img_loading from "assets/img/loading.svg";
import img_calc from "assets/img/calculator.svg";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { useState } from "react";
import { queryCountRowsAssignment } from "service/api";

export const MenuItemButtonCountLines = ({ assignmentId }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      await queryCountRowsAssignment({ assignmentId });
      location.reload()
    } catch (err: any) {
      console.error(err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MenuItemButton
      onClick={handleClick}
      disabled={loading}
      iconSrc={!loading ? img_calc : img_loading}
      title={!loading ? "Посчитать строки" : "Загрузка..."}
    />
  );
};
